import React from "react";
import { Link } from "react-router-dom";
import { TriangleAlert, RefreshCw, Home } from "lucide-react";
import { Button } from "./ui/button";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Route crashed:", error, info);
  }

  reset = () => {
    this.setState({ error: null });
  };

  render() {
    if (!this.state.error) return this.props.children;

    const message = this.state.error?.message || "Something went wrong.";

    return (
      <div className="min-h-[calc(100vh-73px)] flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md text-center" data-testid="route-error-boundary">
          <div className="mx-auto h-14 w-14 rounded-2xl bg-rose-100 text-rose-600 flex items-center justify-center mb-5">
            <TriangleAlert className="h-6 w-6" />
          </div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">
            This page hit a snag
          </h1>
          <p className="text-sm text-slate-500 mt-2">{message}</p>
          <div className="mt-6 flex items-center justify-center gap-2">
            <Button onClick={this.reset} className="bg-brand-primary hover:bg-brand-primary-hover text-white">
              <RefreshCw className="h-4 w-4" />
              Try again
            </Button>
            <Button asChild variant="outline">
              <Link to="/">
                <Home className="h-4 w-4" />
                Go home
              </Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
